import React from "react";
import { LinkedRecords, LinkedRecordType } from "@ofqual/portal-linked-records/linked-records";
import { makeStyles } from "@material-ui/core";
import { SecondaryAppBar } from "../common/SecondaryAppBar";
import { Link } from "react-router-dom";
const useStyles = makeStyles(theme => {
    return {
        scrollableArea: {
            // the scrollable area is pretty much the full height, minus the header area
            height: `calc(100vh - ${
            //theme.contentOffsets.AFTER_RECORD_HEADER
            227}px)`,
            marginLeft: -25,
            marginRight: -25,
            marginBottom: -227,
        },
        inner: {
            position: "relative",
            height: "100%",
            width: "100%",
        },
        content: {
            height: `calc(100%)`,
            // border: "1px solid red/",
            // marginTop: "-15px",
            overflow: "hidden",
            "&::-ms-overflow-style": "none" /* IE and Edge */,
            scrollbarWidth: "none" /* Firefox */,
            "&::-webkit-scrollbar": {
                width: "0px",
                background: "transparent",
                display: "none",
            },
        },
    };
});
export const ComplaintLinkedRecords = ({ id, model }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(SecondaryAppBar, { hasSubBar: true, title: React.createElement(React.Fragment, null,
                React.createElement(Link, { to: `/complaints/list`, "data-test-id": "secondary-header-root-link" }, "/ All cases"),
                " ",
                "/ ",
                model.title) }),
        React.createElement("div", { className: classes.scrollableArea },
            React.createElement("div", { className: classes.inner },
                React.createElement("div", { className: classes.content },
                    React.createElement(LinkedRecords, { entityReferenceId: id, entityTitle: model.title, entityLinkedRecordType: LinkedRecordType.complaint, key: id || "linked-records" }))))));
};
